export const PAGE_ROUTE = {
  ORGANISATION: {
    TEAM_SESSIONS: {
      HOME: "/team-sessions",
    },
  },
};
